import { CommonModule } from '@angular/common';
import {
  Component,
  input,
  output
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconComponent } from 'src/app/core/components/app/app-icon/icon.component';
import { TooltipDirective } from 'src/app/core/directives/tooltip.directive';
import { ClickOnAppBehavior, DisplayType } from 'src/app/core/interfaces/app.interface';
import { StartPageSearchableAppInterface } from 'src/app/core/services/apps-search-service/searchable-app.interface';
import { UrlService } from 'src/app/core/services/url-service/url.service';

@Component({
  selector: 'application-search-result',
  imports: [
    CommonModule,
    IconComponent,
    FormsModule,
    TooltipDirective,
  ],
  templateUrl: './application-search-result.component.html',
  styleUrls: ['./application-search-result.component.scss']
})
export class ApplicationSearchResultComponent {
  app = input.required<StartPageSearchableAppInterface>();
  isClicked = output<void>();
  protected readonly DisplayType = DisplayType;

  constructor(private urlService: UrlService) {}

  private openAppURL(): void {
    this.urlService.openURL(this.app().appURL);
  }

  protected onAppClicked(): void {
    this.isClicked.emit();
    this.openAppURL();
  }

  protected get getAppContainerName(): string {
    const containerName = this.app().folderName ?? this.app().collectionName;
    return containerName ? `In „${containerName}”` : this.app().subtitle ?? '';
  }
}
